/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
/**
 * An enumeration for the different transaction types.
 */
export var TransactionType = /*@__PURE__*/ (function (TransactionType) {
    /**
     * An add transaction.
     */
    TransactionType[TransactionType["Add"] = 0] = "Add";
    /**
     * An update transaction.
     */
    TransactionType[TransactionType["Update"] = 1] = "Update";
    /**
     * A delete transaction.
     */
    TransactionType[TransactionType["Delete"] = 2] = "Delete";
    return TransactionType;
})({});
/**
 * @hidden
 */
export var TransactionType_$type = /*@__PURE__*/ markEnum('TransactionType', 'Add,0|Update,1|Delete,2');
//# sourceMappingURL=TransactionType.js.map
